import {
  DELIVERABLE_ADD_HASHTAGS_ACTION,
  DELIVERABLE_ADD_MENTIONS_ACTION,
  DELIVERABLE_ADD_REPLACE_ZALANDO_PAGE_ACTION,
  DELIVERABLE_ADD_TAGS_ACTION,
  DELIVERABLE_ADD_WMC_LINK_ACTION,
  DELIVERABLE_ADD_ZALANDO_PAGE_ACTION,
  DELIVERABLE_POSTPONE_ACTION,
  DELIVERABLE_REPLACE_COLORED_TAG_ACTION,
  DELIVERABLE_REPLACE_DESCRIPTION_ACTION,
  DELIVERABLE_REPLACE_HASHTAGS_ACTION,
  DELIVERABLE_REPLACE_MENTIONS_ACTION,
  DELIVERABLE_REPLACE_TAGS_ACTION,
  DELIVERABLE_REPLACE_TIMELINE_ACTION,
  DELIVERABLE_REPLACE_WMC_LINK_ACTION,
  DELIVERABLE_REPLACE_ZALANDO_PAGE_ACTION,
  DELIVERABLE_TYPE_BLOG,
  DELIVERABLE_TYPE_INSTAGRAM_POST,
  DELIVERABLE_TYPE_INSTAGRAM_REEL,
  DELIVERABLE_TYPE_INSTAGRAM_STORY,
  DELIVERABLE_TYPE_TIKTOK_VIDEO
} from 'utils/deliverables';

import type { DeliverableType } from 'types';

const SupportedActionTypes: Partial<{
  [k in DeliverableType]: Array<string>;
}> = {
  [DELIVERABLE_TYPE_INSTAGRAM_POST]: [
    DELIVERABLE_ADD_HASHTAGS_ACTION,
    DELIVERABLE_REPLACE_HASHTAGS_ACTION,
    DELIVERABLE_ADD_TAGS_ACTION,
    DELIVERABLE_REPLACE_TAGS_ACTION,
    DELIVERABLE_ADD_MENTIONS_ACTION,
    DELIVERABLE_REPLACE_MENTIONS_ACTION,
    DELIVERABLE_ADD_WMC_LINK_ACTION,
    DELIVERABLE_REPLACE_WMC_LINK_ACTION,
    DELIVERABLE_ADD_REPLACE_ZALANDO_PAGE_ACTION,
    DELIVERABLE_ADD_ZALANDO_PAGE_ACTION,
    DELIVERABLE_REPLACE_ZALANDO_PAGE_ACTION
  ],
  [DELIVERABLE_TYPE_INSTAGRAM_STORY]: [
    DELIVERABLE_ADD_HASHTAGS_ACTION,
    DELIVERABLE_REPLACE_HASHTAGS_ACTION,
    DELIVERABLE_ADD_MENTIONS_ACTION,
    DELIVERABLE_REPLACE_MENTIONS_ACTION,
    DELIVERABLE_ADD_WMC_LINK_ACTION,
    DELIVERABLE_REPLACE_WMC_LINK_ACTION,
    DELIVERABLE_ADD_REPLACE_ZALANDO_PAGE_ACTION,
    DELIVERABLE_ADD_ZALANDO_PAGE_ACTION,
    DELIVERABLE_REPLACE_ZALANDO_PAGE_ACTION
  ],
  [DELIVERABLE_TYPE_INSTAGRAM_REEL]: [
    DELIVERABLE_ADD_HASHTAGS_ACTION,
    DELIVERABLE_REPLACE_HASHTAGS_ACTION,
    DELIVERABLE_ADD_TAGS_ACTION,
    DELIVERABLE_REPLACE_TAGS_ACTION,
    DELIVERABLE_ADD_MENTIONS_ACTION,
    DELIVERABLE_REPLACE_MENTIONS_ACTION,
    DELIVERABLE_ADD_WMC_LINK_ACTION,
    DELIVERABLE_REPLACE_WMC_LINK_ACTION,
    DELIVERABLE_ADD_REPLACE_ZALANDO_PAGE_ACTION,
    DELIVERABLE_ADD_ZALANDO_PAGE_ACTION,
    DELIVERABLE_REPLACE_ZALANDO_PAGE_ACTION
  ],
  [DELIVERABLE_TYPE_TIKTOK_VIDEO]: [
    DELIVERABLE_ADD_HASHTAGS_ACTION,
    DELIVERABLE_REPLACE_HASHTAGS_ACTION,
    DELIVERABLE_ADD_MENTIONS_ACTION,
    DELIVERABLE_REPLACE_MENTIONS_ACTION,
    DELIVERABLE_ADD_WMC_LINK_ACTION,
    DELIVERABLE_REPLACE_WMC_LINK_ACTION,
    DELIVERABLE_ADD_REPLACE_ZALANDO_PAGE_ACTION,
    DELIVERABLE_ADD_ZALANDO_PAGE_ACTION,
    DELIVERABLE_REPLACE_ZALANDO_PAGE_ACTION
  ],
  [DELIVERABLE_TYPE_BLOG]: [
    DELIVERABLE_POSTPONE_ACTION,
    DELIVERABLE_REPLACE_COLORED_TAG_ACTION,
    DELIVERABLE_REPLACE_TIMELINE_ACTION,
    DELIVERABLE_REPLACE_DESCRIPTION_ACTION,
    DELIVERABLE_ADD_WMC_LINK_ACTION,
    DELIVERABLE_REPLACE_WMC_LINK_ACTION,
    DELIVERABLE_ADD_REPLACE_ZALANDO_PAGE_ACTION,
    DELIVERABLE_ADD_ZALANDO_PAGE_ACTION,
    DELIVERABLE_REPLACE_ZALANDO_PAGE_ACTION
  ]
};

const GENERIC_ACTION_TYPES = [
  DELIVERABLE_POSTPONE_ACTION,
  DELIVERABLE_REPLACE_COLORED_TAG_ACTION,
  DELIVERABLE_REPLACE_TIMELINE_ACTION,
  DELIVERABLE_REPLACE_DESCRIPTION_ACTION
];

export function isApplicableDeliverableType(deliverableType: DeliverableType, currentAction: string): boolean {
  return GENERIC_ACTION_TYPES.includes(currentAction)
    || (SupportedActionTypes[deliverableType]?.includes(currentAction) ?? false);
}
